var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url}},[_c('img',{style:(_vm.styleComputed),attrs:{"src":require("../assets/images/apple-podcasts.svg"),"alt":"apple podcasts"}})])}
var staticRenderFns = []

export { render, staticRenderFns }